import type { EntityConfig } from '../types'

export const planEntity: EntityConfig = {
  id: 'plan',
  displayName: 'Plan',
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'active', label: 'Active' },
      { value: 'draft', label: 'Draft' },
      { value: 'archived', label: 'Archived' }
    ],
    options: [
      { value: 'active', label: 'Active', color: 'success' },
      { value: 'draft', label: 'Draft', color: 'pending' },
      { value: 'archived', label: 'Archived', color: 'neutral' }
    ],
    mappings: {
      all: ['active', 'draft', 'archived'],
      active: ['active'],
      draft: ['draft'],
      archived: ['archived']
    }
  },
  queryFields: {
    status: { type: 'status_array', urlKey: 'status' },
    dateRange: { type: 'date_range', urlKey: 'date' },
    createdDate: { type: 'date_range', urlKey: 'createdDate' },
    search: { type: 'search', urlKey: '$s' }
  },
  uiFilterFields: [
    'search',
    'status',
    'createdDate',
  ]
}
